module.exports = __webpack_public_path__ + "static/img/tajmahal.b88e6c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/tajmahal.jpg
// module id = 6WdU
// module chunks = 1